import { render, staticRenderFns } from "./MultilanguageTextConverterControl.vue?vue&type=template&id=bf3f0112&"
import script from "./MultilanguageTextConverterControl.vue?vue&type=script&lang=js&"
export * from "./MultilanguageTextConverterControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports